import { render } from "./uploadVideo.vue?vue&type=template&id=37faba58&scoped=true"
import script from "./uploadVideo.vue?vue&type=script&lang=js"
export * from "./uploadVideo.vue?vue&type=script&lang=js"

import "./uploadVideo.vue?vue&type=style&index=0&id=37faba58&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37faba58"]])

export default __exports__